var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.35 5.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M368 77.5h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009de6",
    transform: "matrix(.26458 0 0 .26458 -97.367 -21.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380 92.5c-.164 0-.326-.04-.471-.118L368 86.233V96.5a3 3 0 0 0 3 3h18a3.003 3.003 0 0 0 3-3V86.233l-11.529 6.15a1 1 0 0 1-.471.117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 79.5h-18a3.003 3.003 0 0 0-3 3v1.467l12 6.4 12-6.4V82.5a3 3 0 0 0-3-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fa520f846b022b3ebbede934a4481ba5.svg";
export { ForwardRef as ReactComponent };